import { render, staticRenderFns } from "./ThesisWithTrueFalseSelectbox.vue?vue&type=template&id=9d92aee6"
import script from "./ThesisWithTrueFalseSelectbox.vue?vue&type=script&lang=js"
export * from "./ThesisWithTrueFalseSelectbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports